import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import AssessmentIcon from "@material-ui/icons/Assessment";
import DescriptionIcon from "@material-ui/icons/Description";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _InfoTabs, _BondsAssessmentForm } from "../components";

export interface IRouteParam {
    ID_Anag: string;
    ID_FideAffidamento: string;
    ID_FideValutazione: string;
}

export const _BondsAssessment: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag, ID_FideAffidamento, ID_FideValutazione } = useParams<IRouteParam>();

    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideValutazioneController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain: Number(ID_FideValutazione) ? 24 : 0, VariabiliMenu: { ["{ID_FideAffidamento}"]: ID_FideAffidamento } });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={AssessmentIcon} Title="Valutazione">
                    {Glob.AzioneAbilitata("FideValutazioneController", Glob.Scrittura) && (
                        <NavLink to={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}/FideValutazione/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                    {ID_FideValutazione && Number(ID_FideValutazione) > 0 && (
                        <a href={`/file/${ID_FideValutazione}`}>
                            <Tooltip title={Trad.Trad("Documenti")}>
                                <IconButton size="small" aria-label="document">
                                    <DescriptionIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoTabs ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} />
                        </Grid>
                        <Grid item xs={12}>
                            <_BondsAssessmentForm />
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BondsAssessment.tsx